import BaseTab from './BaseTab';

export default class UpdateTab extends BaseTab {

  protected getActionType(): string {
    return 'update';
  }

}
